<script>
export default {
  name: "edit-exam"
}
</script>

<template>

</template>

<style scoped>

</style>